import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  CheckCircle,
  Shield,
  Users,
  MapPin,
  Smartphone,
  QrCode,
  Package,
  Bell,
  Globe,
  Phone,
  CreditCard,
  FileText,
  Clock,
  Map,
  UserCheck,
  Shield as ShieldIcon,
} from "lucide-react";
import { HashLink } from "react-router-hash-link";

import "../styles/LandingPage.css";

export default function LandingPage() {
  const [email, setEmail] = useState("");
  const [scrolled, setScrolled] = useState(false);
  const [activeObject, setActiveObject] = useState(0);

  const objects = [
    {
      id: 1,
      icon: <Phone size={20} />,
      title: "Téléphone retrouvé",
      subtitle: "iPhone 14 Pro Max - Noir",
      stats: [
        { value: "24h", label: "Temps moyen" },
        { value: "98%", label: "Taux de retour" },
      ],
      color: "#0066FF",
      details: [
        { icon: <Map size={16} />, text: "Retrouvé à Abidjan, Plateau" },
        {
          icon: <UserCheck size={16} />,
          text: "Propriétaire notifié instantanément",
        },
      ],
    },
    {
      id: 2,
      icon: <CreditCard size={20} />,
      title: "Carte d'identité retrouvée",
      subtitle: "Carte nationale d'identité",
      stats: [
        { value: "12h", label: "Temps moyen" },
        { value: "99%", label: "Taux de retour" },
      ],
      color: "#00B894",
      details: [
        { icon: <Map size={16} />, text: "Retrouvée à Cocody, Riviera" },
        {
          icon: <UserCheck size={16} />,
          text: "Récupérée en point relais sécurisé",
        },
      ],
    },
    {
      id: 3,
      icon: <FileText size={20} />,
      title: "Passeport retrouvé",
      subtitle: "Passeport diplomatique",
      stats: [
        { value: "48h", label: "Temps moyen" },
        { value: "97%", label: "Taux de retour" },
      ],
      color: "#FF6B35",
      details: [
        { icon: <Map size={16} />, text: "Retrouvé à l'aéroport FHB" },
        {
          icon: <UserCheck size={16} />,
          text: "Remis aux autorités compétentes",
        },
      ],
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveObject((prev) => (prev + 1) % objects.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [objects.length]);

  const features = [
    {
      icon: <Shield size={32} />,
      title: "Protection Ultime",
      description:
        "Vos objets importants toujours retrouvables grâce à notre technologie QR",
    },
    {
      icon: <MapPin size={32} />,
      title: "Réseau National",
      description:
        "Points de dépôt sécurisés dans toutes les grandes villes (Bientôt disponible)",
    },
    {
      icon: <Users size={32} />,
      title: "Communauté Solidaire",
      description: "Des milliers d'utilisateurs prêts à vous aider",
    },
    {
      icon: <Smartphone size={32} />,
      title: "Alertes Instantanées",
      description: "SMS et Email dès que votre objet est retrouvé",
    },
  ];

  const pricingPlans = [
    {
      name: "Découverte",
      price: "6 000",
      period: "FCFA / pack",
      description: "Parfait pour commencer",
      features: [
        "5 stickers QR uniques",
        "Notifications SMS",
        "Support par email",
      ],
      buttonVariant: "secondary",
      buttonText: "Commencer",
      planId: "5-stickers", // Ajoutez cet ID
    },
    {
      name: "Premium",
      price: "10 000",
      period: "FCFA / pack",
      popular: true,
      description: "Le choix intelligent",
      features: [
        "10 stickers QR uniques",
        "Notifications SMS & Email",
        "Support prioritaire 24/7",
      ],
      buttonVariant: "primary",
      buttonText: "Choisir cette offre",
      planId: "10-stickers", // Ajoutez cet ID
    },
    {
      name: "Pro",
      price: "15 000",
      period: "FCFA / pack",
      description: "Pour les professionnels",
      features: [
        "20 stickers QR uniques",
        "Notifications SMS & Email & Whatsapp",
        "Support prioritaire 24/7",
      ],
      buttonVariant: "secondary",
      buttonText: "Commencer",
      planId: "20-stickers", // Ajoutez cet ID
    },
  ];

  const stats = [
    { number: "10 000+", label: "Objets protégés" },
    { number: "500+", label: "Points relais" },
    { number: "98%", label: "Taux de réussite" },
    { number: "24h", label: "Support réactif" },
  ];

  const handleSubscribe = (e) => {
    e.preventDefault();
    console.log("Email:", email);
    alert("Merci pour votre inscription !");
    setEmail("");
  };

  return (
    <div className="landing-container">
      {/* Header Moderne */}
      <header className={`landing-header ${scrolled ? "scrolled" : ""}`}>
        <div className="header-content">
          <Link to="/" className="brand">
            <div className="brand-logo">UT</div>
            <span className="brand-name">UltimaTag</span>
          </Link>

          <nav className="nav-links">
            {/* <Link to="#features" className="nav-link">
              Fonctionnalités
            </Link> */}
            <HashLink to="#how-it-works" className="nav-link">
              Comment ça marche
            </HashLink>
            <HashLink to="#pricing" className="nav-link">
              Tarifs
            </HashLink>
            <Link to="/contact" className="nav-link">
              Contact
            </Link>
            {/* <Link to="/admin/login" className="nav-link">
              Admin
            </Link> */}
          </nav>

          <Link to="/payment?plan=10-stickers" className="cta-button">
            <QrCode size={20} />
            Commander vos UTs
          </Link>
        </div>
      </header>

      {/* Hero Section Améliorée */}
      <section className="hero-section-enhanced">
        <div className="hero-bg-pattern"></div>

        <div className="hero-content-enhanced">
          <div className="hero-text">
            <div className="hero-tag">
              <ShieldIcon size={14} style={{ marginRight: "0.5rem" }} />
              Une sécurité en plus
            </div>

            <h1 className="hero-title-enhanced">
              Vos objets perdus
              <br />
              <span>retrouvés en 24h</span>
            </h1>

            <p className="hero-subtitle-enhanced">
              UltimaTag protège vos objets importants avec des stickers QR
              uniques. <br /> En cas de perte, notre communauté vous aide à les
              retrouver rapidement.
            </p>

            <div className="hero-cta-enhanced">
              <HashLink to="#pricing" smooth className="hero-cta-primary">
                Protéger mes objets
                <ArrowRight size={20} />
              </HashLink>

              <div className="hero-badge">
                <CheckCircle size={16} style={{ color: "#00B894" }} />
                <span>Un dernier espoir</span>
              </div>
            </div>

            {/* Stats Bar */}
            <div className="hero-stats-bar">
              <div className="stats-bar-grid">
                <div className="stat-bar-item">
                  <div className="stat-bar-value">1 000+</div>
                  <div className="stat-bar-label">Objets protégés</div>
                </div>
                <div className="stat-bar-item">
                  <div className="stat-bar-value">98%</div>
                  <div className="stat-bar-label">Taux de réussite</div>
                </div>
                <div className="stat-bar-item">
                  <div className="stat-bar-value">24h</div>
                  <div className="stat-bar-label">Temps moyen</div>
                </div>
              </div>
            </div>
          </div>

          {/* Section changeante des objets - CORRIGÉE */}
          <div className="hero-objects-showcase">
            {objects.map((obj, index) => (
              <div
                key={obj.id}
                className={`object-card ${
                  activeObject === index ? "active" : ""
                }`}
                style={{
                  backgroundColor: `${obj.color}20`,
                  borderColor: `${obj.color}40`,
                }}
              >
                <div
                  className="object-icon2"
                  style={{ backgroundColor: obj.color }}
                >
                  {obj.icon}
                </div>

                <h3 className="object-title">{obj.title}</h3>
                <p className="object-subtitle">{obj.subtitle}</p>

                <div className="object-stats">
                  {obj.stats.map((stat, idx) => (
                    <div key={idx} className="stat-item">
                      <div className="stat-value4">{stat.value}</div>
                      <div className="stat-label">{stat.label}</div>
                    </div>
                  ))}
                </div>

                <div className="object-details">
                  {obj.details.map((detail, idx) => (
                    <div
                      key={idx}
                      className="detail-item3"
                      style={{ color: "white" }}
                    >
                      {detail.icon}
                      <span>{detail.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            {/* Indicateurs */}
            <div className="object-indicators">
              {objects.map((_, index) => (
                <button
                  key={index}
                  className={`object-indicator ${
                    activeObject === index ? "active" : ""
                  }`}
                  onClick={() => setActiveObject(index)}
                  aria-label={`Voir l'objet ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features-section">
        <h2 className="section-title2">Pourquoi choisir UltimaTag ?</h2>
        <p className="section-subtitle">
          Une solution complète pour protéger ce qui compte vraiment pour vous
        </p>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="how-it-works">
        <h2 className="section-title2">Comment ça marche ?</h2>
        <p className="section-subtitle">
          Simple, efficace et sécurisé en 3 étapes
        </p>

        <div className="steps-container">
          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number3">1</div>
              <h3 className="step-title">Achetez vos stickers</h3>
              <p className="step-description">
                Commandez votre pack de stickers QR codes uniques
              </p>
            </div>

            <div className="step-card">
              <div className="step-number3">2</div>
              <h3 className="step-title">Associez vos objets</h3>
              <p className="step-description">
                Scannez et enregistrez vos objets avec vos coordonnées
              </p>
            </div>

            <div className="step-card">
              <div className="step-number3">3</div>
              <h3 className="step-title">Tranquillité d'esprit</h3>
              <p className="step-description">
                En cas de perte, soyez alerté immédiatement dès qu'on le
                retrouve
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="pricing-section">
        <h2 className="section-title2">Nos offres</h2>
        <p className="section-subtitle">
          Choisissez la formule qui correspond à vos besoins
        </p>

        <div className="pricing-grid">
          {pricingPlans.map((plan, index) => (
            <div
              key={index}
              className={`pricing-card ${plan.popular ? "popular" : ""}`}
            >
              {plan.popular && (
                <div className="popular-badge">Le plus populaire</div>
              )}

              <h3 className="plan-name">{plan.name}</h3>
              <div className="plan-price">{plan.price}</div>
              <div className="plan-period">{plan.period}</div>
              <p className="plan-description">{plan.description}</p>

              <ul className="plan-features">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="plan-feature">
                    <CheckCircle size={18} />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <Link
                to={`/payment?plan=${plan.planId}`}
                className={`plan-button ${plan.buttonVariant}`}
              >
                {plan.buttonText}
              </Link>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <h2 className="cta-title2">Prêt à sécuriser vos objets ?</h2>
        <p className="cta-description">
          Rejoignez des milliers d'utilisateurs satisfaits et protégez ce qui
          compte vraiment pour vous. <br /> Commencez dès aujourd'hui avec
          UltimaTag.
        </p>
        <Link to="/payment?plan=10-stickers" className="cta-button">
          Commencer maintenant
          <ArrowRight size={20} />
        </Link>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <div className="footer-logo-icon">UT</div>
              <span className="footer-logo-text">UltimaTag</span>
            </Link>
            <p className="footer-tagline">
              La solution ultime pour protéger vos objets importants. <br />
              Innovation, sécurité et tranquillité d'esprit.
            </p>
          </div>

          <div className="footer-links2">
            <h3>Produit</h3>
            <ul>
              <li>
                {" "}
                <HashLink to="#how-it-works" className="nav-link">
                  Comment ça marche
                </HashLink>
              </li>
              <li>
                <HashLink to="#pricing" className="nav-link">
                  Tarifs
                </HashLink>{" "}
              </li>

              <li>
                <Link to="#">Points relais</Link>
              </li>
            </ul>
          </div>

          <div className="footer-links2">
            <h3>Entreprise</h3>
            <ul>
              <li>
                <Link to="/about">À propos</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              {/* <li>
                <Link to="#">Presse</Link>
              </li>
              <li>
                <Link to="#">Carrières</Link>
              </li> */}
            </ul>
          </div>

          <div className="footer-links2">
            <h3>Support</h3>
            <ul>
              <li>
                <Link to="/support">Centre d'aide</Link>
              </li>
              {/* <li>
                <Link to="/faq">FAQ</Link>
              </li> */}
              {/* <li>
                <Link to="/legal">Mentions légales</Link>
              </li> */}
              <li>
                <Link to="/privacy">Confidentialité</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} UltimaTag. Tous droits réservés.</p>
          <p style={{ marginTop: "0.5rem", fontSize: "0.75rem" }}>
            Conçu avec ❤️ pour protéger vos objets
          </p>
        </div>
      </footer>
    </div>
  );
}
